import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import MediaQueryContextProvider from './MediaQueryContext';
import TenantContextProvider from './TenantContext';
import ThemeSwitch from './ThemeSwitch';

const LMSProviders = ({ env, tenant, subdomain, query, children }: LMSProvidersProps) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <SnackbarProvider
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        classes={{ containerAnchorOriginBottomRight: 'snackbar' }}
      >
        <TenantContextProvider {...{ env, tenant, subdomain }}>
          <ThemeSwitch>
            <MediaQueryContextProvider>{children}</MediaQueryContextProvider>
          </ThemeSwitch>
        </TenantContextProvider>
      </SnackbarProvider>
    </MuiPickersUtilsProvider>
  );
};

export default LMSProviders;

type LMSProvidersProps = {
  env: LMSEnv;
  children: React.ReactNode;
  tenant: Tenant;
  subdomain: string;
  query: any;
};
